module.exports = __webpack_public_path__ + "static/img/P5.99e4d67b.png";